import React, { useState, useEffect } from 'react'
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  DeleteButton,
  ShowButton,
  useResourceContext,
  useResourceDefinitions,
  useTranslate,
  useStore,
} from 'react-admin'
import { Paper, Container } from '@mui/material'
import { MyTooltip } from 'src/helper/toolTipWrapper'

export const AirDetailList = (props) => {
  const translate = useTranslate()
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  return (
    <>
      <Container className='content'>
        <Paper className='paper_content'>
          <List {...props} component='div'>
            <Datagrid rowClick='show'>
              <TextField source='id' label={translate('ra.field.id')} />
              <TextField source='airline' label={translate('ra.field.airline')} />
              <TextField source='date_out' label={translate('ra.field.date_out')} />
              <TextField source='date_in' label={translate('ra.field.date_in')} />
              <MyTooltip title='Ver detalle' aria-label='show'>
                {permissions?.hasShow ? <ShowButton label='' /> : <div />}
              </MyTooltip>
              <MyTooltip title={translate('ra.action.edit')} aria-label='edit'>
                {permissions?.hasEdit ? <EditButton label='' /> : <div />}
              </MyTooltip>
              <MyTooltip title={translate('ra.action.delete')} aria-label='delete'>
                {permissions?.options?.delete ? <DeleteButton label='' /> : <div />}
              </MyTooltip>
            </Datagrid>
          </List>
        </Paper>
      </Container>
    </>
  )
}
